<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card>
          <v-container class="py-0">
            <v-row>
              <v-col xs="12" sm="12" md="6" lg="4" xl="4">
                <v-combobox
                  :items="vehiculos"
                  item-text="plate"
                  item-value="id"
                  no-filter
                  prepend-icon="mdi-truck"
                  label="Seleccionar vehículo"
                  v-debounce:750ms="consultarVehiculos"
                  v-model="patente"
                  :rules="[
                    rules.required(),
                  ]"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="12" md="8" lg="6" xl="4">
                <v-row>
                  <v-col>
                    <v-datetime-picker
                      label="Fecha desde"
                      date-format="yyyy-MM-dd"
                      time-format="HH:mm"
                      clearText="Limpiar"
                      okText="OK"
                      v-model="desde"
                      :rules="[
                        rules.required(),
                      ]"
                    >
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock</v-icon>
                      </template>
                    </v-datetime-picker>
                  </v-col>
                  <v-col>
                    <v-datetime-picker
                      label="Fecha hasta"
                      date-format="yyyy-MM-dd"
                      time-format="HH:mm"
                      clearText="Limpiar"
                      okText="OK"
                      v-model="hasta"
                      :rules="[
                        rules.required(),
                      ]"
                    >
                      <template slot="dateIcon">
                        <v-icon>mdi-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>mdi-clock</v-icon>
                      </template>
                    </v-datetime-picker>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="8" xl="6">
                <v-btn
                  color="success"
                  :loading="loading_fms1"
                  :disabled="loading_fms1"
                  @click="descargar('fms1')"
                  class="mr-5 mb-5"
                >
                  FMS1
                </v-btn>
                <v-btn
                  color="success"
                  :loading="loading_fms4"
                  :disabled="loading_fms4"
                  @click="descargar('fms4')"
                  class="mr-5 mb-5"
                >FMS4</v-btn>
                <v-btn
                  color="success"
                  :loading="loading_behaviour"
                  :disabled="loading_behaviour"
                  @click="descargar('behaviour')"
                  class="mr-5 mb-5"
                >Drive Behaviour</v-btn>
                <v-btn
                  color="success"
                  :loading="loading_state"
                  :disabled="loading_state"
                  @click="descargar('state')"
                  class="mr-5 mb-5"
                >State</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, minSize } from '@/utils/rules'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      vehiculos: [],
      errors: [],
      rules: { required, minSize },
      loading_fms1: false,
      loading_fms4: false,
      loading_behaviour: false,
      loading_state: false,
      patente: '',
      desde: '',
      hasta: '',
    }
  },
  created() {
    let h = new Date()
    this.hasta = h
    let d = new Date()
    d.setDate(h.getDate() - 7)
    this.desde = d
  },
  methods: {
    ...mapActions('snackbar', ['updateSnackbarText']),
    consultarVehiculos(a_buscar) {
      this.$axios
        .get('/query/vehicles?search=' + a_buscar)
        .then(response => {
          this.vehiculos = response.data
        })
        .catch(e => {
          //e
          this.errors.push(e)
          // console.log(e)
          this.updateSnackbarText('Error al consultar los vehiculos')
        })
    },
    descargar(request_type) {
      if (this.patente.id == undefined) {
        this.updateSnackbarText('Falta elegir el vehiculo')
      }
      else {
        this['loading_'+request_type] = true

        let idvehiculo = this.patente.id

        let d = new Date(this.desde)
        let desde = d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':00'

        let h = new Date(this.hasta)
        let hasta = h.getFullYear() + '-' + ('0' + (h.getMonth()+1)).slice(-2) + '-' + ('0' + h.getDate()).slice(-2) + 'T' + ('0' + h.getHours()).slice(-2) + ':' + ('0' + h.getMinutes()).slice(-2) + ':00'

        let data = '{"id": ' + idvehiculo + ', "from": "' + desde + '", "to": "' + hasta + '"}'

        this.$axios
          .post('/query/' + request_type, data)
          .then((response) => {
            // // var fileURL = window.URL.createObjectURL(new Blob([response.data]))
            var csv = this.convertToCSV(response.data)
            var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
            var fileURL = window.URL.createObjectURL(new Blob([blob]))
            var fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', request_type + '.csv')
            document.body.appendChild(fileLink)
            fileLink.click()
            this['loading_'+request_type] = false
          })
          .catch(e => {
            //e
            this.errors.push(e)
            // console.log(e)
            // TODO: tirar mensaje diferente si responde pero sin resultados
            this.updateSnackbarText('Error al descargar los datos')
            this['loading_'+request_type] = false
          })
      }
    },
    convertToCSV(objArray) {
      const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray
      let str = ''

      let headers = Object.keys(array[0])
      let line = ''
      headers.forEach(function(header) {
        if (line != '') line += ';'
        line += header
      })
      str += line + '\r\n'

      for (let i = 0; i < array.length; i++) {
        let line = ''
        for (let index in array[i]) {
          if (line != '') line += ';'
          line += array[i][index]
        }
        str += line + '\r\n'
      }

      return str
    },
  },
}
</script>